import React, { useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import useUserStore from '../store/useUserStore'
import { removeLocalStorage } from '../utils/common'

interface AuthProviderProps {
  children: React.ReactNode
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const userInfo = useUserStore((state) => state.userInfo)

  const isInAppBrowser = (): boolean => {
    const userAgent: string =
      navigator.userAgent ||
      navigator.vendor ||
      (window as Window & { opera?: string }).opera ||
      ''

    return /(FBAN|FBAV|Instagram|Threads|Barcelona|Line|KAKAOTALK|NAVER|TikTok|InApp)/i.test(
      userAgent,
    )
  }

  useEffect(() => {
    if (isMobile) {
      const isInApp = isInAppBrowser()
      if (isInApp) {
        const url = window.location.href
        const userAgent: string =
          navigator.userAgent ||
          navigator.vendor ||
          (window as Window & { opera?: string }).opera ||
          ''

        // 임시: UserAgent 확인용 디버깅
        // alert(`UserAgent: ${userAgent}`)

        // Threads 앱 전용 처리
        if (/Threads|Barcelona/i.test(userAgent)) {
          if (/android/i.test(userAgent)) {
            // Android Threads: Chrome 인텐트 시도
            const intentUrl = `intent://${url.replace(
              /^https?:\/\//,
              '',
            )}#Intent;scheme=https;package=com.android.chrome;end;`
            window.location.href = intentUrl

            // 실패 대비 안내
            // setTimeout(() => {
            //   alert(
            //     '외부 브라우저에서 열기를 위해 우상단 메뉴(⋯)에서 "브라우저에서 열기"를 선택해주세요.',
            //   )
            // }, 1000)
          } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
            // iOS Threads: Safari로 직접 열기 시도
            // window.location.href = `x-web-search://?${encodeURIComponent(url)}`
            window.location.href =
              'kakaotalk://web/openExternal?url=' + encodeURIComponent(url)

            // 실패 대비 안내
            // setTimeout(() => {
            //   alert(
            //     '외부 브라우저에서 열기를 위해 우하단 공유 버튼에서 "Safari에서 열기"를 선택해주세요.',
            //   )
            // }, 1000)
          }
        } else if (/android/i.test(userAgent)) {
          const intentUrl = `intent://${url.replace(
            /^https?:\/\//,
            '',
          )}#Intent;scheme=https;package=com.android.chrome;end;`
          window.location.href = intentUrl
        } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
          window.location.href =
            'kakaotalk://web/openExternal?url=' + encodeURIComponent(url)
        }
      } else {
        const userAgent: string =
          navigator.userAgent ||
          navigator.vendor ||
          (window as Window & { opera?: string }).opera ||
          ''
        // alert(`no inApp UserAgent: ${userAgent}`)
      }
    }
  }, [])

  useEffect(() => {
    if (userInfo && !userInfo?.affiliate?.point) {
      removeLocalStorage('affiliate_source')
      removeLocalStorage('affiliate_campaign')
    }

    if (window.ChannelIO && userInfo) {
      window.ChannelIO('boot', {
        pluginKey: process.env.REACT_APP_CHANNEL_TALK_KEY,
        memberId: userInfo.userInfo?.id ?? 0,
        profile: {
          name: userInfo.userInfo?.name,
          email: userInfo.userInfo?.email,
        },
      })
    } else if (window.ChannelIO && !userInfo) {
      window.ChannelIO('boot', {
        pluginKey: '56355af5-b4ef-4ef1-b558-a496ca3c9831',
      })
    }
  }, [userInfo])

  return <>{children}</>
}
